"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopiaMonthInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
function TopiaMonthInput(props) {
    var actualType = "date";
    if (props.type)
        actualType = props.type;
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    // return (
    // <div className={classNames("flex", props.className)}>
    //   <div className={classNames()}>
    //     <label
    //       htmlFor={props.id}
    //       className="block text-sm font-medium text-topia-gray"
    //     >
    //       {props.label}
    //     </label>
    //     <div className="mt-1">
    //       <select
    //         {...props.inputProps}
    //         className={BASE_INPUT_CLASSES}
    //         id={`${props.id}-month`}
    //       >
    //         <option value={1}>January</option>
    //         <option value={2}>February</option>
    //         <option value={3}>March</option>
    //         <option value={4}>April</option>
    //         <option value={5}>May</option>
    //         <option value={6}>June</option>
    //         <option value={7}>July</option>
    //         <option value={8}>August</option>
    //         <option value={9}>September</option>
    //         <option value={10}>October</option>
    //         <option value={11}>November</option>
    //         <option value={12}>December</option>
    //       </select>
    //     </div>
    //   </div>
    //   <div className={classNames()}>
    //     <label
    //       htmlFor={props.id}
    //       className="block text-sm font-medium text-topia-gray"
    //     >
    //       {props.label}
    //     </label>
    //     <div className="mt-1">
    //       <input
    //         {...props.inputProps}
    //         type={actualType}
    //         id={props.id}
    //         className={BASE_INPUT_CLASSES}
    //       />
    //     </div>
    //   </div>
    // </div>
    // );
}
exports.TopiaMonthInput = TopiaMonthInput;
